import { theme } from '@/theme';

export const styles = {
  layoutWrapper: {
    display: 'flex',
    minHeight: '100vh',
    background: theme.colors.bg,
    fontFamily: theme.typography.fontFamily,
  },

  sidebar: {
    width: theme.sizes.sidebarWidth,
    background: theme.colors.sidebar.bg,
    borderRight: `1px solid ${theme.colors.border}`,
    display: 'flex',
    flexDirection: 'column' as const,
    padding: '0 12px 16px',
    flexShrink: 0,
    boxShadow: theme.shadows.sm,
    position: 'sticky' as const,
    top: 0,
    height: '100vh',
    overflowY: 'auto' as const,
    zIndex: 200,
  },

  sidebarBrand: {
    height: theme.sizes.headerHeight,
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '0 8px',
    borderBottom: `1px solid ${theme.colors.divider}`,
    marginBottom: 8,
  },

  logoBox: {
    width: 32,
    height: 32,
    background: theme.colors.primary,
    borderRadius: theme.radius.md,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.colors.text.inverse,
    fontWeight: theme.typography.fontWeight.extrabold,
    fontSize: '1rem',
  },

  logoTextHeading: {
    fontSize: '0.9375rem',
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.text.heading,
  },

  logoTextSub: {
    fontSize: '0.6875rem',
    color: theme.colors.text.muted,
  },

  navContainer: {
    flex: 1,
    overflowY: 'auto' as const,
    paddingRight: 4,
  },

  signOutBtn: {
    width: '100%',
    border: 'none',
    cursor: 'pointer',
    color: theme.colors.dangerDark,
    background: 'none',
    fontFamily: theme.typography.fontFamily,
  },

  mainArea: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column' as const,
    minWidth: 0,
  },

  header: {
    height: theme.sizes.headerHeight,
    background: theme.colors.surface,
    borderBottom: `1px solid ${theme.colors.border}`,
    padding: '0 28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'sticky' as const,
    top: 0,
    zIndex: 100,
  },

  headerTitle: {
    fontSize: theme.typography.fontSize.sm,
    color: theme.colors.text.muted,
  },

  profileBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontFamily: theme.typography.fontFamily,
    padding: '4px 6px',
    borderRadius: theme.radius.lg,
  },

  profileAvatar: {
    background: theme.colors.success,
    fontSize: '0.75rem',
  },

  dropdownMenu: {
    position: 'absolute' as const,
    top: '110%',
    right: 0,
    zIndex: 150,
    minWidth: 200,
  },

  dropdownUserHeader: {
    padding: '10px 12px 6px',
    borderBottom: `1px solid ${theme.colors.divider}`,
    marginBottom: 4,
  },

  mainContent: {
    flex: 1,
    padding: '28px 32px',
    overflowY: 'auto' as const,
  },
} as const;
